export default __webpack_public_path__ + "static/media/delivered.20df46a4.svg";